export const CATEGORY_REDUCER_NAME = 'category'
export const ALL_CATEGORIES_LIST_REDUCER_NAME = 'allCategoriesList'
